import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { Usuario } from './Interfaces';
import { GlobalService } from './Servicios/global.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  currentUser: Usuario;
  public global: GlobalService;
  title = 'Soat';

  nombreModulo: string[] = [];
  rutaRegresar: string = "";
  constructor(
    private router: Router,
    private globalService: GlobalService
  ) { }

  ngOnInit() {
    this.global = this.globalService
  }
  logout() {
    this.router.navigate(['autenticacion/login'], { skipLocationChange: true });
    sessionStorage.clear();
  }
  onActivate(componentReference) {
    componentReference.actNombreModulo.subscribe((data: string[]) => {
      this.nombreModulo = data;
    });

    componentReference.ruta.subscribe((ruta: string) => {
      this.rutaRegresar = ruta;
    });
  }

}